import {DxComboDatasource} from "../../../dx-forms/domain/combo/dx-combo-datasource";
import {Observable} from "rxjs";
import {DxComboElementDataProvider} from "../../../dx-forms/domain/combo/dx-combo-element-data-provider";
import {PitNciComboElement} from "./pit-nci-combo-element";
import {fromPromise} from "rxjs/internal-compatibility";
import {Injectable} from "@angular/core";
import {DxHttpDispatcher} from "../../../dx-core/services/dx-http-dispatcher.service";
import {DxNciService} from "../../../dx-nci-core/services/dx-nci.service";


@Injectable()
export class PitNciBackendComboDatasource implements DxComboDatasource {

  constructor(private _http: DxHttpDispatcher,
              private _nciService: DxNciService) {
  }

  fetchElements(filter?: Map<string, Object>, sorts?: Map<string, string>): Observable<DxComboElementDataProvider[]> {
    // Идент справочника можно пробрасывать через фильтры
    // Сами фильтры можно описывать в опциях комбика.
    const dictIdent: string = <string>filter.get('DICT_IDENT');
    const promise = new Promise<DxComboElementDataProvider[]>((resolve, reject) => {
      this._nciService.fetchBackendDictionary(dictIdent).subscribe(response => {
        const items = response.elements;
        const elements: DxComboElementDataProvider[] = [];
        items.forEach(item => {
          elements.push(new PitNciComboElement(item))
        });
        resolve(elements);
      }, error => {
        reject(error);
      });
    });
    return fromPromise<DxComboElementDataProvider[]>(promise);
  }

}
